module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_10.b28e60d9.png";